import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAllContractBeneficiaries } from '../hooks/useAllContractBeneficiaries';
import { BeneficiariesModalContent } from './BeneficiariesModalContent';
export const BeneficiariesPage = ({ isOpen, contractId, onClose, 'data-testid': dataTestId, }) => {
    const { beneficiaries, isLoading, isError, refetch } = useAllContractBeneficiaries({
        contractId,
        enabled: isOpen && Boolean(contractId),
    });
    return (_jsx(BeneficiariesModalContent, { isOpen: isOpen, onClose: onClose, beneficiaries: beneficiaries, isLoading: isLoading, isError: isError, onRetry: refetch, "data-testid": dataTestId }));
};
